var ui_templates = require("ui-templates");
var lib_core           = require("lib-core");

var SnapGridView = function(root,stateMachine,editorView,model, editorModel) {
    var self = this;
    this.root = root;
    this.model = model;
    this.editorModel = editorModel;
    this.stateMachine = stateMachine;
    this.editorView = editorView;
    this.initialize();

    if(this.editorModel.sidebarModel()){
        this.editorModel.sidebarModel().show.onChange(this, function(){
                self.snapTool.positionToggle();
        },3);
    }
};

SnapGridView.prototype.initialize = function(){
	var self = this;
	this.snapTool = this.editorView.getTemplate().addSnapTool();
	this.snapTool.$el.on('Cioui:SnapTool:clicked', function (e, value) {
		 var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.GUI_SNAP_GRID_CHANGE)
                .data( 'value', value );
        return self.stateMachine.handle(cEvent);
	});
};

module.exports = SnapGridView;
